@import 'src/styles/common/_colors.scss';

.circleContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: -40px;
  flex-shrink: 0;
  transition: all 0.3s ease-in-out;
  
  // Hover effect for better interactivity
  &:hover {
    transform: scale(1.05);
  }
}

.circleInner {
  position: absolute;
  text-align: center;
  border-radius: 50%;
  font-family: "Open Sans", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  transition: all 0.3s ease-in-out;
}

// Variants for different sizes
.small {
  .circle {
    width: 32px;
    height: 32px;
  }
  
  .circleInner {
    width: 20px;
    height: 20px;
    font-size: 9px;
  }
}

.medium {
  .circle {
    width: 44px;
    height: 44px;
  }
  
  .circleInner {
    width: 27px;
    height: 27px;
    font-size: 11px;
  }
}

.large {
  .circle {
    width: 56px;
    height: 56px;
  }
  
  .circleInner {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }
}

// Color variants
.success {
  .circle {
    background: conic-gradient(#28a745 var(--progress), rgba(40, 167, 69, 0.3) var(--progress)) !important;
  }
}

.warning {
  .circle {
    background: conic-gradient(#ffc107 var(--progress), rgba(255, 193, 7, 0.3) var(--progress)) !important;
  }
}

.danger {
  .circle {
    background: conic-gradient(#dc3545 var(--progress), rgba(220, 53, 69, 0.3) var(--progress)) !important;
  }
}

.info {
  .circle {
    background: conic-gradient(#17a2b8 var(--progress), rgba(23, 162, 184, 0.3) var(--progress)) !important;
  }
}